import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    // 浏览器前进/后退保持原生历史位置
    if (savedPosition) {
      return savedPosition
    }

    // 同一路径下（query/hash 变化）交给业务侧手动滚动，避免和评论锚点/翻页逻辑互相干扰
    if (to.path === from.path) {
      return false
    }

    // 跨页面导航改为页面完成后再滚动，避免“先回顶再加载”
    return false
  }
}
